export default __webpack_public_path__ + "static/media/IntegrationSMS.a28d0878.pdf";